import { useCallback, useState } from "react";
import axiosInstance from "../axiosInstance";

const usePatchWeddingTimeline = () => {
  const [loading, setLoading] = useState(false);

  const mutate = useCallback(({ chatId, timeline }) => {
    const baseUrl = window.localStorage.getItem("BaseURL");
    const endpoint = `/services/projectmanagement/api/ai-bot/chat/timeline/${chatId}`;
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      setLoading(true);
      axiosInstance
        .patch(fullUrl, { timeline })
        .then((res) => resolve(res.data))
        .catch(reject)
        .finally(() => {
          setLoading(false);
        });
    });
  }, []);

  return { mutate, loading };
};

export default usePatchWeddingTimeline;
